import { formatCurrency } from "@/utils/format/currency";
import { CycleDetailsProps } from "./cycle-details.types";
import { formatInTimeZone } from "date-fns-tz";
import { CalculateCycleConsumption } from "@/utils/calculate-cycle-consumption";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const CycleDetails = ({
  activeCycle,
  additionalCredits,
  upsellCredits,
  showConsumption = true,
  className = "",
}: CycleDetailsProps) => {
  const { newCreditAmount, newCreditConsumption } = CalculateCycleConsumption(
    activeCycle,
    additionalCredits,
    upsellCredits,
  );

  const detailRows = [
    {
      items: [
        {
          label: "ID do ciclo",
          value: String(activeCycle?.id || ""),
        },
        {
          label: "Data de início",
          value: activeCycle
            ? formatInTimeZone(activeCycle.startDate, "UTC", "dd/MM/yyyy")
            : "",
        },
        {
          label: "Data de fim",
          value: activeCycle
            ? formatInTimeZone(activeCycle.endDate, "UTC", "dd/MM/yyyy")
            : "",
        },
      ],
    },
    {
      items: [
        {
          label: "Quantidade de créditos",
          value: `${newCreditAmount} créditos`,
        },
        ...(showConsumption
          ? [
              {
                label: "Créditos disponíveis",
                value: `${Math.max(0, newCreditAmount - newCreditConsumption)} créditos`,
              },
            ]
          : []),
      ],
    },
    {
      items: [
        ...(showConsumption
          ? [
              {
                label: "Utilizados por escritório privativo",
                value: `${newCreditConsumption} créditos`,
              },
            ]
          : []),
        {
          label: "Valor unitário do crédito",
          value: formatCurrency(activeCycle?.credits?.unitPrice ?? 0),
        },
      ],
    },
    {
      items: [
        {
          label: "Valor do crédito excedente",
          value: formatCurrency(activeCycle?.credits?.exceededPrice ?? 0),
        },
        {
          label: "Cortesias",
          value: `${activeCycle?.credits?.courtesy ?? 0} créditos`,
        },
      ],
    },
  ];

  return (
    <div className={className}>
      <CardHeader className="px-4 py-2 space-y-2">
        <CardTitle className="text-bg-black text-2xl font-medium leading-tight pt-2">
          Ciclo
        </CardTitle>
        <CardDescription className="text-sm text-muted-foreground font-normal leading-tight pb-2 whitespace-nowrap">
          Referente ao ciclo correspondente com a data de início desta reserva.
        </CardDescription>
      </CardHeader>
      <CardContent className="p-0 w-full overflow-hidden">
        {detailRows.map((row, rowIndex) => {
          return (
            <div
              key={rowIndex}
              className={`grid border-t-2 grid-cols-${row.items.length}`}
            >
              {row.items.map((item, itemIndex) => (
                <div
                  key={item.label}
                  className={`p-3 ${
                    itemIndex < row.items.length - 1 ? "border-r-2" : ""
                  }`}
                >
                  <div className="flex flex-col gap-1">
                    <div className="text-sm font-semibold">{item.value}</div>
                    <div className="text-sm text-muted-foreground">
                      {item.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </CardContent>
    </div>
  );
};
